import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    uid: "",
    name: "",
    poolId: "",
    email: "",
    pool: null,
    lastUpdate: 1767247200,
  },
  reducers: {
    setUser: (state, action) => {
      return { ...action.payload };
    },
    clearUser: () => {
      return {
        uid: "",
        name: "",
        poolId: "",
        email: "",
        pool: null,
        lastUpdate: 1767247200,
      };
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export const UserReducer = userSlice.reducer;
